export default "__VITE_ASSET__Bz2yq0OR__"